import { useCallback, useContext } from 'react'

import { AuthenticationContext } from '../../providers/auth-provider'

const getLocalTemperatureUnits = () => {
  const locale = navigator.language || 'en-US'

  // Extract country code from strings like "en-US", "es-PR", etc.
  const country = locale.split('-')[1]

  // List of countries heavily relying on Fahrenheit
  const fahrenheitCountries = ['US', 'LR', 'MM', 'PR', 'VI', 'GU', 'AS', 'KY']

  return fahrenheitCountries.includes(country) ? 'F' : 'C'
}

const useTemperatures = () => {
  const { ownUser } = useContext(AuthenticationContext)
  const tempUnits = ownUser?.preferences?.tempUnits ? (ownUser.preferences.tempUnits === 'degF' ? 'F' : 'C') : getLocalTemperatureUnits() // If no temperature format is selected, infer from locale

  const tempFormat: TemperatureFormat = tempUnits === 'F' ? 'degF' : 'degC'

  const formatTemperature = useCallback(
    (temp: number, rounding: 'tenths' | 'integer' = 'tenths', fromUnit = 'degF', showUnit = true) => {
      let temperature = temp
      if (tempFormat === 'degC' && fromUnit === 'degF') {
        temperature = (temp - 32) * (5 / 9)
      }
      if (tempFormat === 'degF' && fromUnit === 'degC') {
        temperature = temp * (9 / 5) + 32
      }
      const roundedTemp = rounding === 'integer' ? Math.round(temperature) : Math.round(temperature * 10) / 10

      return showUnit ? `${roundedTemp}°` : roundedTemp
    },
    [tempFormat]
  )

  return { formatTemperature, tempUnits, tempFormat }
}

export default useTemperatures
